"use strict";
var React = require("react");
var Modal = require("react-bootstrap").Modal;
var closeButton = require("react-bootstrap").closeButton;
var Button = require("react-bootstrap").Button;
var ButtonToolbar = require("react-bootstrap").ButtonToolbar;
var InventoryActions = require("../../actions/InventoryActions");
import { numberWithCommas } from '../../utils/helpers';
var _ = require("underscore");


var InsureInventoryItemFormModal = React.createClass({
  onSubmit(event) {
    event.preventDefault();
    _.map(this.props.equipment, function(eq) {
      eq.insured = true;
      InventoryActions.editItem(eq);
    });
    this.props.onHide();
  },
  mapItems: function(item) {
    return (
      <div key={item.id}>
        <div className="equipment-list-item">
          <div className="eq">{item.brand_name}</div>
          <div className="eq">{item.name}</div>
          <div className="eq eq-price">{numberWithCommas(item.purchase_price)+"kr."}</div>
        </div>
      </div>
    );
  },
  render: function() {
    return (
      <Modal className="drawer" {...this.props} bsStyle="primary" animation={true}>
        <Modal.Body>
          <div id="deleteInventoryItemModal" className="modal-body">
            <div className="text-center"><h3>Viltu tryggja valinn búnað?</h3><p>-</p></div>
            <div id="equipmentList">
              <div className="equipment-list-container">
                {_.map(this.props.equipment, this.mapItems)}
                <div className="equipment-list-item">
                  <div className="eq eq-price">Samtals tryggt: {numberWithCommas(this.props.valueToInsure)+' kr.'}</div>
                </div>
                <div className="equipment-list-item">
                  <div className="eq eq-price">Samtals verð: <strong>{numberWithCommas(this.props.valueToInsure*0.03/12)+" kr. á mánuði"}</strong></div>
                </div>
                <div className="equipment-list-item">
                  <div className="eq eq-price"><button className="btn btn-primary" onClick={this.onSubmit}>Tryggja</button></div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar>
            <div className="text-right">
              <Button onClick={this.props.onHide}>Loka</Button>
            </div>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    );
  }
});

module.exports = InsureInventoryItemFormModal;



// WEBPACK FOOTER //
// ./app/scripts/ui/Inventory/InsureInventoryItemFormModal.js